
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { RoleItemProps } from ".";
import { loading, index, options } from "store/role";

interface ApiRoleInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiRoleOutputProps = OutputBaseProps<{ list: RoleItemProps[]; pagination?: PaginationProps; }>

export const apiRoleIndex = async (data: ApiRoleInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiRoleOutputProps>("/api/roles", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiRoleOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiRoleOutputProps>("/api/roles", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};